import { MuiTelInputCountry } from 'mui-tel-input';
import { useTranslation } from 'react-i18next';
import { PhoneConsentText } from 'src/components/PhoneConsentText';
import { useSession } from 'src/contexts/SessionContext';
import { FormDatePicker } from 'src/shared/Forms/Fields/FormDatePicker';
import { FormPhoneInput } from 'src/shared/Forms/Fields/FormPhoneInput';
import { FormSelect } from 'src/shared/Forms/Fields/FormSelect';
import { FormTextField } from 'src/shared/Forms/Fields/FormTextField';
import { FormLocationSelect } from 'src/shared/Forms/Selects/LocationSelect';
import { FormTimezoneSelect } from 'src/shared/Forms/Selects/TimezoneSelect';

interface ProfileFieldItem {
  name: string;
  id: string;
  value: any;
}

type Props = { field: ProfileFieldItem; name: string };

export const ProfileField = ({ field, name }: Props) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'client.newClientPage',
  });
  const { t: tPersonalInfo } = useTranslation('translation', {
    keyPrefix: 'client.personalInfo',
  });
  const { t: tGlobal } = useTranslation('translation');

  const { session } = useSession();

  switch (field.id) {
    case 'phone_number':
      return (
        <>
          <FormPhoneInput
            name={name}
            required
            defaultCountry={session.country as MuiTelInputCountry}
            preferredCountries={
              [session.country || 'US', 'US'] as MuiTelInputCountry[]
            }
            variant="outlined"
          />
          <PhoneConsentText isTrainer />
        </>
      );
    case 'location_id':
      return <FormLocationSelect name={name} />;
    case 'gender':
      return (
        <FormSelect
          name={name}
          options={[
            { label: t('selectGender'), value: null as unknown as string },
            { label: tPersonalInfo('male'), value: 'Male' },
            { label: tPersonalInfo('female'), value: 'Female' },
            { label: tPersonalInfo('other'), value: 'Other' },
          ]}
          fast
        />
      );
    case 'birthdate':
      return <FormDatePicker name={name} label="" />;
    case 'uses_metric':
      return (
        <FormSelect
          name={name}
          fast
          options={
            [
              {
                value: null,
                label: t('selectMeasurement'),
              },
              {
                value: false,
                label: tGlobal('profileLayout.Imperial (lbs, mi)'),
              },
              {
                value: true,
                label: tGlobal('profileLayout.Metric (kgs, kms)'),
              },
            ] as any
          }
        />
      );
    case 'time_zone':
      return <FormTimezoneSelect name={name} label="" />;
    default:
      return <FormTextField name={name} placeholder={t('enterValue')} fast />;
  }
};
